import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUp } from "lucide-react";
import GradientBackground from "@/components/GradientBackground";

export default function Impressum() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen text-white relative overflow-x-hidden" data-testid="impressum-page">
      <GradientBackground />

      <nav className="sticky top-0 z-40 bg-black/70 backdrop-blur-xl border-b border-[#ff0090]/30">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center">
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-white/70 hover:text-white transition-colors" data-testid="back-to-home">
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Link>
        </div>
      </nav>

      <main className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="bg-black/50 backdrop-blur-md border-2 border-[#ff0090]/40 rounded-3xl p-6 sm:p-10 shadow-xl shadow-[#ff0090]/10">
          <h1 className="font-['Outfit'] text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-8" data-testid="impressum-title">
            Impressum
          </h1>

          <div className="space-y-8 text-white/70">
            <section>
              <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-3">Angaben gemäß § 5 TMG</h2>
              <p className="leading-relaxed">
                UCL Legacy UG (haftungsbeschränkt)<br />
                Grimmstraße 12<br />
                36381 Schlüchtern<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-3">Kontakt</h2>
              <p className="leading-relaxed">
                E-Mail: support@ucllegacy.com
              </p>
            </section>

            <section>
              <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-3">Vertretungsberechtigte Personen</h2>
              <p className="leading-relaxed">
                Geschäftsführung: Matthias Gucze
              </p>
            </section>

            <section>
              <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-3">Handelsregister</h2>
              <p className="leading-relaxed">
                Registergericht: Amtsgericht Hanau<br />
                Registernummer: HRB 100594
              </p>
            </section>

            <section>
              <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-3">Umsatzsteuer-ID</h2>
              <p className="leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                DE455520024
              </p>
            </section>

            <section>
              <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-3">Haftungsausschluss</h2>
              
              <h3 className="font-semibold text-white/90 mt-4 mb-2">Haftung für Inhalte</h3>
              <p className="leading-relaxed text-sm">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>

              <h3 className="font-semibold text-white/90 mt-4 mb-2">Haftung für Links</h3>
              <p className="leading-relaxed text-sm">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-[#ff0090] text-white shadow-lg shadow-[#ff0090]/40 flex items-center justify-center transition-all duration-300 hover:bg-[#ff0090]/80 hover:scale-110 ${
          showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        data-testid="scroll-to-top-btn"
        aria-label="Nach oben scrollen"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </div>
  );
}
